import { pipe,Observable } from 'rxjs';
import { filter, distinctUntilChanged, withLatestFrom, startWith, pairwise, map, takeUntil  } from 'rxjs/operators';
import { isEqual , pickBy } from 'lodash';
import { select } from '@ngrx/store';

import { possibleValues, selectValue,selectProperty } from '@app/core/store/selectors';
/**
 * Custom pure functions to be used as custom operators
 */
/**
 * This operator checks the distinct values of any kind of object
 */
export const distinctUntilBeChanged = pipe(filter(Boolean), distinctUntilChanged(isEqual));
/**
 * This operator selects the possible values of a field from ngrx state
 * @param ctx
 * @param field
 */
export const selectPossibleValues = (ctx: any, field: string) =>
  pipe(
    select(possibleValues, {
      ...ctx,
      field
    }),
    distinctUntilBeChanged
  );
/**
 *
 * This operator selects the value of a screen from ngrx state
 *
 */
export const selectData = (ctx: any) =>
  pipe(
    select(selectValue, { ...ctx }),
    filter((value) => value !== undefined && !(value instanceof Array))
  );
/**
 * This operator selects the modified property of a screen from ngrx state
 * @param ctx
 * @param property
 * @param data$
 */

/**
 *
 * This operator selects the form value of a screen from ngrx state
 *
 */
export const selectFormData = (ctx: any) =>
  pipe(
    select(selectValue, { ...ctx }),
    filter((value) => value !== undefined && !(value instanceof Array)),
    startWith({}),
    pairwise(),
    map(([oldValue, newValue]) => {
      return oldValue ? pickBy(newValue, (value, key) => !isEqual(value, oldValue[key])) : newValue;
    })
  );
export const selectPropertyToModify = (ctx: object, property: string, data$: Observable<any>) =>
pipe(select(selectProperty, {​​ ...ctx, property: 'propertyToModify' }​​),
filter(data => data === property),
withLatestFrom(data$))
/**
 * This operator checks the emitted query parameter `reload`
 * to recall the sub routes
 */
 export const selectReloadParameter = (destroy$) => pipe(filter((item: any) => item.reload), takeUntil(destroy$));
